import Vue from "vue";
import { State, Action } from "vuex-class";
import axios from "axios";
import { API_BASE_URL } from "@/utils/conf";
import GhBase from "@/components/ghBase";
import { RouteConfig } from "vue-router";
import { Mixins, Component } from "vue-property-decorator";
import GhClassService from "@/utils/mixins/clsService";
import { MethodService } from "@/utils/serviceModel";
import { VNode } from "vue";
import ModuleService from '@/utils/mixins/moduleService';


@Component
export default class Index extends ModuleService {
    private isBusy = false;
    private target = 'server';
    private rootPage: RouteConfig = { name, path: '', component: undefined };

    @State(state => state.appconfig)
    private setting: IndexObject;

    @Action("getAppconfig")
    private getAppconfig;

    async created() {
        // this.$router.push("home");
        await this.getAppconfig();
        if (this.setting.target === this.target) {
            this.$router.push("home");
        }
        else {
            Vue.prototype.$setLoading = (flag?: boolean) => {
                if (flag) {
                    this.isBusy = true;
                } else {
                    this.isBusy = false;
                }
            };
            await this.loadAsyncComponents();
            this.queryPages();
        }
    }

    private toHome() {
        if (this.rootPage.name !== undefined) {
            this.$router.push({ name: this.rootPage.name });
        }
    }

    private async queryPages() {
        let rs: RouteConfig = {
            name: "index",
            path: "/index",
            component: () => import("@/portal/index/index")
        };
        let result = await this.service.invokeAsyn({ home: this.setting.home });
        if (result.data.isSuccess && result.data.data != null) {
            let ids: string[] = result.data.data[0];
            let pages: IndexObject = result.data.data[1];
            await this.loadPages(rs, ids, pages, []);
            if (rs.children !== undefined && rs.children.length > 2) {
                this.rootPage = rs.children[2];
                this.$router.push({ name: rs.children[2].name });
            }
        }
    }

    private service: MethodService = new MethodService(
        "dynamic_parse_page",
        "61de6e4feec2ea1740bd7b6a",
        "getMenus"
    );
}
